var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-col", { staticClass: "mt-2" }, [
    _c(
      "div",
      {
        staticClass: "accordion",
        staticStyle: { width: "100%" },
        attrs: { role: "tablist" }
      },
      [
        _c(
          "div",
          { staticClass: "accordion-wrapper" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: `${_vm.id}-features`,
                    expression: "`${id}-features`"
                  }
                ]
              },
              [
                _c(
                  "div",
                  { staticClass: "row align-items-center no-gutters" },
                  [
                    _c("div", { staticClass: "col d-flex" }, [
                      _c("i", {
                        class: `fa-fw fa-check-circle check-icon mr-2 ${
                          _vm.isCovered ? "fas" : "far"
                        }`
                      }),
                      _c("div", [
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(_vm.tankName))
                        ]),
                        _c("p", { staticClass: "receives-features-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isCovered
                                  ? _vm.$t("xReceivesPremiumFeatures")
                                  : _vm.$t("xNotIncludedInPlan")
                              ) +
                              " "
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "col-auto" }, [
                      _c("i", {
                        staticClass: "fas fa-chevron-down when-closed"
                      }),
                      _c("i", { staticClass: "fas fa-chevron-up when-open" })
                    ])
                  ]
                )
              ]
            ),
            _c("b-collapse", { attrs: { id: `${_vm.id}-features` } }, [
              _c("div", { staticClass: "features" }, [
                _c("div", { staticClass: "premium" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("xFeaturesIncluded")))])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "fa-regular fa-gas-pump" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "p",
                        {
                          attrs: {
                            "data-test-hook":
                              "tank-features-list-current-level-title"
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xCurrentFuelLevel")))
                          ])
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "supporting-text",
                          attrs: {
                            "data-test-hook":
                              "tank-features-list-current-level-desc"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xFuelLevelDescription")) + " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "fa-regular fa-chart-line" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "p",
                        {
                          attrs: {
                            "data-test-hook":
                              "tank-features-list-fuel-use-title"
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xFuelUsageHistory")))
                          ])
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "supporting-text",
                          attrs: {
                            "data-test-hook": "tank-features-list-fuel-use-desc"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xFuelUsageDescription")) + " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "fa-regular fa-warning" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "p",
                        {
                          attrs: {
                            "data-test-hook":
                              "tank-features-list-warnings-title"
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xFuelLevelWarnings")))
                          ])
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "supporting-text",
                          attrs: {
                            "data-test-hook": "tank-features-list-warnings-desc"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xFuelLevelWarningsDescription")) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "fa-regular fa-battery-full" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "p",
                        {
                          attrs: {
                            "data-test-hook": "tank-features-list-battery-title"
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xBatteryLevel")))
                          ])
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "supporting-text",
                          attrs: {
                            "data-test-hook": "tank-features-list-battery-desc"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xBatteryLevelDescription")) +
                              " "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }